import { render, staticRenderFns } from "./FilePicker.vue?vue&type=template&id=bf6609be&scoped=true&"
import script from "./FilePicker.vue?vue&type=script&lang=ts&"
export * from "./FilePicker.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bf6609be",
  null
  
)

export default component.exports